export const FETCH_ALL = 'blogcategories_List';

export const FETCH = 'blogcategories_FindById';

export const CREATE = 'blogcategories_CreateOne';

export const EDIT = 'blogcategories_UpdateById';

export const DELETE = 'blogcategories_RemoveManyByIds';
